enum CustomerElectonicAddressGroup {
  PRIMARY = 'PRIMARY',
  ALTERNATIVE = 'ALTERNATIVE',
}

export default CustomerElectonicAddressGroup;
